import {
  SWEEPSTAKES_QUERY,
  SUBMIT_SWEEPSTAKES_ENTRY_MUTATION,
  SWEEPSTAKES_ENTRY_STATUS_QUERY,
} from '../../../graphql/snackMadness';
import { client } from '../../utilities/config';

/**
 * Fetch sweepstakes by tag (openDate, closeDate from backend sweepstakes table).
 * @param {string} sweepstakesTag - e.g. 'snack-madness-2026'
 * @returns {Promise<{ id: string, sweepstakesTag: string, openDate: string, closeDate: string, status: number }|null>}
 */
export const getSweepstakesByTag = (sweepstakesTag) => {
  return client
    .query({
      query: SWEEPSTAKES_QUERY,
      variables: { sweepstakesTag },
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data?.sweepstakes ?? null)
    .catch(() => null);
};

/**
 * Submit sweepstakes entry. Backend uses auth customer_id; throws GraphQLException for errors.
 * @param {{ sweepstakesTag: string }} input
 * @returns {Promise<{ success: boolean, message?: string }>}
 */
export const submitSnackMadnessEntry = (input) => {
  const defaultErrorMsg = 'Something went wrong. Please try again.';
  return client
    .mutate({
      mutation: SUBMIT_SWEEPSTAKES_ENTRY_MUTATION,
      variables: { input },
    })
    .then((res) => {
      const errs = res?.errors;
      if (errs && errs.length > 0) {
        const msg = errs[0].message || defaultErrorMsg;
        return Promise.reject(new Error(msg));
      }
      return res.data?.submitSweepstakesEntry ?? { success: false };
    })
    .catch((err) => {
      const msg =
        err?.graphQLErrors?.[0]?.message ?? err?.message ?? defaultErrorMsg;
      throw new Error(msg);
    });
};

/**
 * Check if the current user has already submitted an entry for this sweepstakes.
 * @param {string} sweepstakesTag - sweepstakes_tag for the contest
 * @returns {Promise<boolean>}
 */
export const getSnackMadnessEntryStatus = (sweepstakesTag) => {
  return client
    .query({
      query: SWEEPSTAKES_ENTRY_STATUS_QUERY,
      variables: { sweepstakesTag },
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data?.sweepstakesEntryStatus === true)
    .catch(() => false);
};
